import React, { useState, useContext, useEffect } from "react";
import { cerrarSessionModal, formatRUT, hideSideBarDesktop, tokenExpirado } from "../utils/funciones";
import { obtenerDatosPersonaSolicitanteAction } from "../redux/datosPersonaSolicitanteDucks";
import { guardarSolicitudReingreso } from "../api/contratacion/solicitudVacanteApi";
import { mensajeSimple, modalCargando } from "./ui/sweetAlerts";
import { DataContext } from "../contextData/contextData";
import { useReingreso } from "../hooks/datosLaborales";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { validateRut } from "rutlib/lib";
import rut from "@mlezcano1985/rut-formatter";
import { useFormik } from "formik";
import Spinner from "./ui/Spinner";
import Swal from "sweetalert2";

const ConsultarRutScreen = () => {
  const dispatch = useDispatch();
  const { setReingreso } = useReingreso();
  const { setearPagina } = useContext(DataContext);
  const personSolicitante = useSelector(store => store.datosPersonaSolicitante);
  const loading = useSelector(store => store.datosPersonaSolicitante.loading);
  const [viewMsj, setViewMsj] = useState(false);
  const navigate = useNavigate();

  const validate = values => {
    const errors = {};
    if (!values.rut) {
      errors.rut = "Debe ingresar un rut.";
    }
    if (values.rut && !validateRut(values.rut)) {
      errors.rut = "El rut es invalido.";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: { rut: "" },
    validate,
    onSubmit: values => {
      setReingreso(false);
      verificarRut(values);
    },
  });

  const verificarRut = async values => {
    if (tokenExpirado(localStorage.getItem("token"))) {
      cerrarSessionModal();
      return;
    }

    modalCargando("Consultando...");
    const response = await dispatch(obtenerDatosPersonaSolicitanteAction(values.rut));
    response ? Swal.close() : setTimeout(() => Swal.close(), 20000);

    setViewMsj(response);
  };

  const iniciarSolicitudTrabajadorAntiguio = async idPersona => {
    const txt = "Se procederá a enviar a validación para posteriormente continuar con el proceso.";
    Swal.fire({
      icon: "info",
      title: txt,
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "red",
      showLoaderOnConfirm: true,
      reverseButtons: false, // orden botones al reves
      customClass: {
        container: "containerMensajeSimple",
        title: "titleMensajeSimple",
        text: "txtLabellInput",
        popup: `popUpSweetCancelarEnviar`,
        confirmButton: "btnCopec me-4",
        cancelButton: "btnAtras",
      },
      buttonsStyling: false,
      preConfirm: () => {
        return guardarSolicitudReingreso(idPersona)
          .then(response => {
            if (response.status !== "success") {
              throw new Error(response.message);
            }
            return response;
          })
          .catch(error => {
            Swal.showValidationMessage(error);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(result => {
      if (result.isConfirmed) {
        mensajeSimple("success", "Solicitud ingresada correctamente", 3000);
        setViewMsj(false);
      }
    });
  };

  useEffect(() => {
    hideSideBarDesktop();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-3 my-2"></div>
        <div className="col-12 col-md-6 my-2 justify-content-center d-flex">
          <div className="card" style={{ width: "500px" }}>
            <div className="card-header bgArcopime">Verificación de RUT a contratar</div>
            <div className="card-body">
              <form onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <div className="d-flex flex-direction-row justify-content-between align-items-baseline mb-1">
                    <label htmlFor="rut" className="form-label mb-0">
                      Rut solicitante
                    </label>
                    {formik.errors.rut ? <span className="badge rounded-pill bg-danger">{formik.errors.rut}</span> : null}
                  </div>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    id="rut"
                    maxLength={10}
                    aria-describedby="rutHelper"
                    onChange={e => {
                      const txt = e.target.value.replace(/([A-JL-Za-jl-zÑñ.,\-:;´¿¡+=_!@#$%~^&*('"{><`/?}|)\s[\]])/g, "");
                      formik.setValues({
                        ...formik.values,
                        rut: rut.format(txt) !== null ? rut.format(txt).replaceAll(".", "") : txt.replaceAll(".", ""),
                      });
                    }}
                    value={formik.values.rut.replaceAll(".", "")}
                  />
                </div>
                <div className="d-grid gap-2">
                  <button type="submit" className={`btn btn-primary cursor-${formik.errors.rut ? "not-allowed" : "pointer"}`} title={formik.errors.rut ? "Ingrese un rut válido" : "Consultar"}>
                    Consultar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3 my-2"></div>
      </div>
      {personSolicitante.dataPersona.rut && viewMsj && personSolicitante.dataPersona.status !== "info" && (
        <div className="row mt-3">
          <div className="col-12 col-md-3"></div>
          <div className="col-12 col-md-6 justify-content-center d-flex">
            <div className="card" style={{ width: "500px" }}>
              <div className="card-header bgArcopime">Observaciones</div>
              {loading && !personSolicitante.dataPersona.rut ? (
                <Spinner />
              ) : (
                <div className="card-body">
                  <h6>{personSolicitante.dataPersona.rut ? `Rut consultado: ${formatRUT(personSolicitante.dataPersona.rut)}` : null}</h6>
                  <div className="d-grid gap-2">
                    {!personSolicitante.dataPersona.data.bloqueado && !personSolicitante.dataPersona.data.registro_sap && (
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          if (tokenExpirado(localStorage.getItem("token"))) {
                            cerrarSessionModal();
                            return;
                          }
                          setearPagina(0);
                          navigate("/formulario-contratacion");
                        }}
                      >
                        Ingresar contratación
                      </button>
                    )}
                  </div>
                  {!personSolicitante.dataPersona.data.bloqueado && personSolicitante.dataPersona.data.registro_sap && (
                    <div className="mb-3 mt-2">
                      <div className="alert alert-warning" role="alert">
                        La Gerencia de Personas determinó que este ex-colaborador que intenta reingresar, fue desvinculado(a) con una causal que REQUIERE VALIDACIÓN por parte de Procesos & Remuneraciones para continuar con su proceso.
                      </div>
                      <div className="d-grid gap-2">
                        <button className="btn btn-success" data-bs-toggle="tooltip" onClick={() => iniciarSolicitudTrabajadorAntiguio(personSolicitante.dataPersona.data.id_persona)}>
                          Iniciar solicitud
                        </button>
                      </div>
                    </div>
                  )}

                  {personSolicitante.dataPersona.data.bloqueado && (
                    <div className="mb-3 mt-2">
                      <div className="alert alert-danger" role="alert">
                        La Gerencia de Personas determinó que este ex-colaborador que intenta reingresar, fue desvinculado(a) con una Causal que NO PERMITE continuar con su proceso.
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-md-3"></div>
        </div>
      )}
      {personSolicitante.dataPersona.status === "info" && (
        <div className="row my-5">
          <div className="col-12 col-md-3"></div>
          <div className="col-12 col-md-6 justify-content-center d-flex">
            <div className="card" style={{ width: "500px" }}>
              <div className="alert alert-info mb-0 text-center" role="alert">
                <b>{personSolicitante.dataPersona.message}</b>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3"></div>
        </div>
      )}
    </>
  );
};

export default ConsultarRutScreen;
